module.exports = __webpack_public_path__ + "static/media/expand-arrows.3c93528f.svg";